import axiosInstance from "./axios";
import config from "./config";
import moment from "moment";
import { getParsedItem } from "../utilities/localstorage";
import { convertDateStringToArray, getLocalTime } from "../utilities/shipmentTable";
import { validateEmptyOrNull } from "../utilities/libs";

export const fetchShipments = async (filterConditions, sortBy, sortOrder, page, availableDates, isSearchParamsAction = false, userDetails) => {
	try {
		const isCustomerUser = userDetails.isCustomerUser === true;
		const customerName = userDetails.customerName;
	    const localTime = getLocalTime();

        let dates = [];
        // for search action, all available dates will be considered.
		if (isSearchParamsAction) {
            dates = availableDates.map(date => moment(new Date(date)).format('YYYYMMDD'));
        } else {// chosen dates are applicable for filter action.
            dates = convertDateStringToArray(filterConditions?.SelectedDate) || [moment().format("YYYYMMDD")];
        }

        const payload = {
			SelectedDate: dates,
			page: page,
			// Default sorting
			SortBy: sortBy || "DeliveryAppointment",
			SortOrder: sortOrder || "ascending",
			clientTime: localTime,
		};

		// UPDATED: Only send CustomerId for Niagara users (not customer users)
		// Customer users' filtering will be handled automatically by backend
		if (!isCustomerUser && !isSearchParamsAction && filterConditions?.CustomerId) {
			payload.CustomerId = filterConditions.CustomerId;
		}

        // Filters should be considered only while applying filters action.
		if (!isSearchParamsAction && filterConditions) {
			if (filterConditions.City) payload.City = filterConditions.City;
			if (filterConditions.Warehouse) payload.warehouse = filterConditions.Warehouse;
			if (filterConditions.DeliveryStatus !== null) {
				payload.DeliveryStatus = filterConditions.DeliveryStatus;
			}
			if (filterConditions.CustomerRegion !== null) {
				payload.CustomerRegion = filterConditions.CustomerRegion;
			}
			// Add reschedule flag to payload if it exists in filter conditions
			if (filterConditions.reschedule !== undefined) {
				payload.reschedule = filterConditions.reschedule;
			}
			// Add autoRecovery flag to payload if it exists in filter conditions
			if (!validateEmptyOrNull(filterConditions.autoRecovery)) {
				payload.autoRecovery = filterConditions.autoRecovery;
			}
		}
        // consider search params only for search action, ignoring the filters applied.
        if (isSearchParamsAction && filterConditions?.SearchQuery) {
            payload.isSearchAction = true;
            const searchQuery = filterConditions.SearchQuery.trim();
            if (searchQuery.startsWith("PONumber:")) {
                payload.PONumber = searchQuery.split(":")[1].trim();
            } else if (searchQuery.startsWith("DeliveryNumber:")) {
                payload.DeliveryNumber = searchQuery.split(":")[1].trim();
            } else if (searchQuery.startsWith("NBNumber:")) {
                payload.NBNumber = searchQuery.split(":")[1].trim();
            }
		}

		if (sortBy) {
			payload.SortBy = sortBy;
			payload.SortOrder = sortOrder;
		}

		const response = await axiosInstance.post(config.endpoints.shipment_data_url, payload);

		if (response.status === 200) {
			return response.data;
		} else if (response.status === 404) {
			return { shipments: [], hasMore: false, nextPage: null };
		} else {
			throw new Error("Failed to fetch shipments");
		}
	} catch (error) {
		console.error("Error fetching shipments:", error);
		throw error;
	}
};
